import { Product } from "@deliverr/commons-clients";
import { compact, uniq } from "lodash";
import { getStorageProductDsku } from "./getStorageProductDsku";

export const getUniqueStorageItemSkus = (
  storageItems: { dsku: string }[],
  productDetails?: { [dsku: string]: Product }
) => uniq(compact(storageItems.map((item) => getStorageProductDsku(productDetails?.[item.dsku]) ?? item.dsku)));
